// ant design table的排序，搜索功能
import {trim} from "core-js/internals/string-trim";
import {newContractRule} from "../../utils/utils";
import {compareNumbers} from "../../vueComponents/utils";
export const tableOperationMixin = {
    data() {
        return {
            searchConditionTag: [],//搜索tag
            searchText: '',
            inputSearch: '',
            sortConditionTag: [],
            filteredInfo: null,
            filteredVisible: true,
            tableSearchList: [],
        }
    },
    methods: {
        // 搜索
        handleSearch(setSelectedKeys, selectedKeys, confirm, column, clearFilters, type,errors={}) {
            var range = type === 'range'
            let time = type === 'time'
            let selectValue=selectedKeys[0]
            if (range) {
                if(errors.first('rangeMax')||errors.first('rangeMin')){
                    this.$message.error('范围格式错误，请输入数字')
                    return;
                }
                if (selectedKeys[0] !== undefined && selectedKeys[1] !== undefined) {
                    if (compareNumbers(selectedKeys[0] ,selectedKeys[1])>0) {
                        this.$message.error('搜索范围出错，请确保搜索的最大值大于或者等于最小值')
                        return
                    }
                    selectValue = selectedKeys[0] + ' 至 ' + selectedKeys[1]
                } else if (selectedKeys[0] === undefined && selectedKeys[1] === undefined) {
                    // 两个都没填
                } else if (selectedKeys[0] === undefined) {
                    //只填了最大值
                    selectValue = ' 至 ' + selectedKeys[1]
                } else if (selectedKeys[1] === undefined) {
                    //只填了最小值
                    selectValue = selectedKeys[0] + ' 至 '
                }
            }
            if (time) {
                if (selectedKeys[0] === undefined && selectedKeys[1] === undefined) {
                    //都未填写
                } else if (selectedKeys[0] === undefined) {
                    //未填最小日期
                    selectValue = new Date(selectedKeys[1]).toDateString().replaceAll('/', '-')
                    selectValue = "2023-01-01" + ' 至 ' + selectedKeys[1]
                } else if (selectedKeys[1] === undefined) {
                    selectValue = selectedKeys[0]
                    selectValue = selectedKeys[0] + ' 至 '
                } else {
                    selectValue = selectedKeys[0] + ' 至 ' + selectedKeys[1]
                }
            }
            if(column.key==='contractNo'&&newContractRule(selectValue)){
                selectValue=selectValue.replace(/^(BZ)([D|F]?)(\d{14})$/, "$1$3")
            }
            let isSearchTag = this.searchConditionTag.map(item => item.key).includes(column.key)
            let length = this.searchConditionTag.length
            if (isSearchTag) {
                let searchIndex = -1
                for (let i = 0; i < length; i++) {
                    if (this.searchConditionTag[i].key === column.key) {
                        if (selectValue) {
                            this.searchConditionTag[i].value = selectValue
                            this.searchConditionTag[i].newSearchValue = (range||time)?trim(selectValue).replace(' 至 ',','):trim(selectValue)
                            searchIndex = i
                            break
                        }
                    }
                }
                if (searchIndex === -1) {
                    this.searchConditionTag.splice(searchIndex - 1, 1)
                }
            } else {

                //搜索值不为空
                let newSearchKey = column.key
                if (this.isOpenNewSearch) {
                   newSearchKey=this.getNewKey( column.key,'search',column.searchMethod)
                }
                if (selectedKeys[0] !== undefined) {
                    this.searchConditionTag.push({
                        title: (column.questionTitle?column.questionTitle:column.title),
                        key: column.key,
                        newSearchKey: `query#${newSearchKey}`,
                        value: trim(selectValue),
                        clearFilters: clearFilters,
                        newSearchValue:(range||time)?trim(selectValue).replace(' 至 ',','):trim(selectValue)
                    })
                }
            }
            confirm()
            // 为内部的条件搜索赋值
            if (!this.$refs.searchSortTag) {
                this.$refs.wMyTable.searchConditionTag = this.searchConditionTag
            }
            this.updatePageDataBySearch()
        },
        // 删除选择的
        deleteSelect(item, index) {
            if (window.location.search && this.$route && Object.keys(this.$route.query)&&!this.isExcludeRoutePath) {
                if(this.$route.query.fixParam){
                    let params = JSON.parse(this.$route.query.fixParam).reduce((pre, current) => {
                        // 拼接每个查询参数，返回更新后的字符串
                        return `${pre}&${current}=${this.$route.query[current]}`;
                    }, '');
                    this.$router.push(`${this.$route.path}?${params}`)
                }else {
                    this.$router.push(this.$route.path)
                }
            }
            this.searchConditionTag.splice(index, 1)
            if (!this.$refs.searchSortTag) {
                this.$refs.wMyTable.searchConditionTag = this.searchConditionTag
            }
            this.updatePageDataBySearch()
        },
        // 重置
        handleReset(column, clearFilters) {
            clearFilters()
        },
        // table改变时
        changeTable(pagination, filters, sorter) {
            let sortName = ''
            this.sortConditionTag = []
            const elements = document.querySelectorAll('.ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner .ant-table-column-sorter-up.on, .ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner .ant-table-column-sorter-down.on');
            // 遍历每个匹配的元素并移除样式
            elements.forEach(element => {
                element.removeAttribute('style');
            })
            if (sorter) {
                let order = ''
                if (sorter.order) {
                    if (sorter.order === 'ascend') {
                        sortName = '升序'
                        order = 'asc'
                    } else {
                        sortName = '降序'
                        order = 'desc'
                        sorter.order = 'descend'
                    }
                    let newSortKey = sorter.column.key
                    if (this.isOpenNewSearch) {
                        newSortKey=this.getNewKey( sorter.column.key,'sort')
                    }
                    this.sortConditionTag.push({
                        order: order,
                        colName: sorter.columnKey,
                        title: (sorter.column.questionTitle?sorter.column.questionTitle:sorter.column.title),
                        newSortKey:newSortKey+`.${order}`,
                        sortName: sortName
                    })
                    if (!this.$refs.searchSortTag) {
                        this.$refs.wMyTable.sortConditionTag = this.sortConditionTag
                    }
                    this.updatePageData()
                }
            }

        },
        // 删除排序
        deleteSort() {
            this.sortConditionTag = []
            //内层未封装的搜索
            if (!this.$refs.searchSortTag) {
                this.$refs.wMyTable.sortConditionTag = this.sortConditionTag
            }
            // 将本身table的排序恢复初始
            if (this.$refs.tables.$children) {
                this.$refs.tables.$children[0].sSortColumn = null
            }
            this.updatePageData()
        },
        // 获取新key
        getNewKey(columnKey,type,method) {
            if (!method){
                method='EQ'
            }
            let keys = columnKey.split('.')
            if(type==='search'){
                let newSearchKey = ''
                if (keys.length > 1) {
                    newSearchKey='JSON'
                    keys.forEach((key, index) => {
                        if (index === keys.length - 1) {
                            newSearchKey = newSearchKey + `@${key}.${method}`
                        } else {
                            newSearchKey = newSearchKey + `$${key}`
                        }
                    })
                } else {
                    newSearchKey = keys[0]+`.${method}`
                }
                return newSearchKey
            }else {
                return  keys.length>1?'json:'+keys.join(':'):columnKey
            }

        },
    }
}

